export const elementId = 'imageContainer';
